import { DateObject } from 'react-multi-date-picker';

export const getDay = (date: DateObject) => {
  return [new DateObject(date), new DateObject(date)];
};
